(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[74],{

/***/ 20271:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/marcas",
      function () {
        return __webpack_require__(86589);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 86589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* reexport */ all_brands; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var esm = __webpack_require__(62624);
// EXTERNAL MODULE: ./src/containers/default/getServerSideProps.js
var getServerSideProps = __webpack_require__(5349);
// EXTERNAL MODULE: ./src/containers/default/page.js + 16 modules
var page = __webpack_require__(25442);
// EXTERNAL MODULE: ./src/utils/withCustomError.js
var withCustomError = __webpack_require__(54026);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../modules/build/esm/novisual/GoogleTagManagerNoscript/index.js
var GoogleTagManagerNoscript = __webpack_require__(59462);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/AdsBanner/index.js + 5 modules
var AdsBanner = __webpack_require__(10369);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/ExternalContent/index.js + 3 modules
var ExternalContent = __webpack_require__(41593);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/HeaderDesktop/index.js + 5 modules
var HeaderDesktop = __webpack_require__(89634);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/Heading/index.js + 1 modules
var Heading = __webpack_require__(89940);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/Link/index.js + 1 modules
var Link = __webpack_require__(94978);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/CustomPagination/index.js + 1 modules
var CustomPagination = __webpack_require__(46933);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/BrandList/index.js + 2 modules
var BrandList = __webpack_require__(53842);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/FooterDesktop/index.js + 3 modules
var FooterDesktop = __webpack_require__(87764);
// EXTERNAL MODULE: ../modules/build/esm/novisual/Ebit/index.js
var Ebit = __webpack_require__(53213);
// EXTERNAL MODULE: ../modules/build/esm/novisual/ReclameAqui/index.js
var ReclameAqui = __webpack_require__(9039);
// EXTERNAL MODULE: ../modules/build/esm/novisual/Favicon/index.js
var Favicon = __webpack_require__(80995);
// EXTERNAL MODULE: ../modules/build/esm/novisual/Preconnect/index.js
var Preconnect = __webpack_require__(42438);
// EXTERNAL MODULE: ../modules/build/esm/novisual/Datadog/index.js
var Datadog = __webpack_require__(64002);
// EXTERNAL MODULE: ../modules/build/esm/novisual/GoogleTagManagerHead/index.js
var GoogleTagManagerHead = __webpack_require__(14499);
// EXTERNAL MODULE: ../modules/build/esm/novisual/Stewie/index.js
var Stewie = __webpack_require__(48517);
// EXTERNAL MODULE: ../modules/build/esm/novisual/AllIn/index.js
var AllIn = __webpack_require__(82896);
// EXTERNAL MODULE: ../modules/build/esm/novisual/Criteo/index.js
var Criteo = __webpack_require__(63760);
// EXTERNAL MODULE: ../modules/build/esm/novisual/TikTok/index.js
var TikTok = __webpack_require__(62300);
// EXTERNAL MODULE: ../modules/build/esm/novisual/SpotifyAdAnalytics/index.js
var SpotifyAdAnalytics = __webpack_require__(66775);
// EXTERNAL MODULE: ../modules/build/esm/novisual/RTBHouse/index.js
var RTBHouse = __webpack_require__(50682);
// EXTERNAL MODULE: ../modules/build/esm/novisual/Vwo/index.js + 1 modules
var Vwo = __webpack_require__(2159);
// EXTERNAL MODULE: ../modules/build/esm/novisual/Azion/index.js
var Azion = __webpack_require__(14286);
// EXTERNAL MODULE: ../modules/build/esm/novisual/Bing/index.js
var Bing = __webpack_require__(94842);
;// CONCATENATED MODULE: ./src/containers/all-brands/pageModules.js
/* eslint-disable */ 
























var pageModules = {
    GoogleTagManagerNoscript: GoogleTagManagerNoscript/* default */.Z,
    AdsBanner: AdsBanner/* default */.ZP,
    ExternalContent: ExternalContent/* default */.Z,
    HeaderDesktop: HeaderDesktop/* default */.Z,
    Heading: Heading/* default */.Z,
    Link: Link/* default */.Z,
    CustomPagination: CustomPagination/* default */.Z,
    BrandList: BrandList/* default */.Z,
    FooterDesktop: FooterDesktop/* default */.Z,
    Ebit: Ebit/* default */.Z,
    ReclameAqui: ReclameAqui/* default */.Z,
    Favicon: Favicon/* default */.Z,
    Preconnect: Preconnect/* default */.Z,
    Datadog: Datadog/* default */.Z,
    GoogleTagManagerHead: GoogleTagManagerHead/* default */.Z,
    Stewie: Stewie/* default */.Z,
    AllIn: AllIn/* default */.Z,
    Criteo: Criteo/* default */.Z,
    TikTok: TikTok/* default */.Z,
    SpotifyAdAnalytics: SpotifyAdAnalytics/* default */.Z,
    RTBHouse: RTBHouse/* default */.Z,
    Vwo: Vwo/* default */.Z,
    Azion: Azion/* default */.Z,
    Bing: Bing/* default */.Z,
    ZipCodeInput: dynamic_default()(function() {
        return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 40261));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(40261)
                ];
            }
        },
        ssr: false
    }),
    Loader: dynamic_default()(function() {
        return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 79331));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(79331)
                ];
            }
        },
        ssr: false
    })
};
/* harmony default export */ var all_brands_pageModules = (pageModules);

;// CONCATENATED MODULE: ./src/containers/all-brands/pageConfig.json
var pageConfig_namespaceObject = JSON.parse('{"routeAlias":{},"routeId":"all-brands","routePath":"/marcas/","siteId":"magazineluiza"}');
;// CONCATENATED MODULE: ./src/containers/all-brands/index.js










var _routeAlias = pageConfig_namespaceObject.routeAlias, routeAlias = _routeAlias === void 0 ? {} : _routeAlias, config = (0,_object_without_properties/* default */.Z)(pageConfig_namespaceObject, [
    "routeAlias"
]);
var AllBrands = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(page/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        modules: all_brands_pageModules
    }));
};
var all_brands_getServerSideProps = function() {
    var ctx = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref, ref1;
    var resolvedUrl = ((ref1 = (ref = ctx.resolvedUrl) === null || ref === void 0 ? void 0 : ref.split("?")) === null || ref1 === void 0 ? void 0 : ref1[0]) || pageConfig.routePath;
    var query = objectRemoveMatchedKey(ctx.query || {}, routeAlias);
    var params = objectConvertAlias(ctx.params || {}, routeAlias);
    return defaultGetServerSideProps(_object_spread_props(_object_spread({}, ctx, config), {
        params: params,
        query: query,
        resolvedUrl: resolvedUrl
    }));
};
/* harmony default export */ var all_brands = ((0,withCustomError/* default */.Z)(AllBrands));

;// CONCATENATED MODULE: ./src/pages/marcas/index.js
// eslint-disable-next-line prettier/prettier
var __N_SSP = true;



/***/ }),

/***/ 54026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25237);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_error__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70689);
/* eslint-disable react/prop-types */ /* eslint-disable react/display-name */ /* eslint-disable import/no-unresolved */ 



var Custom404 = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 7975).then(__webpack_require__.bind(__webpack_require__, 47975)).catch(function() {
        return null;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(47975)
            ];
        }
    }
});
var withCustomError = function(Page) {
    var CustomErrorPage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Custom404;
    return function(props) {
        var _structure = props.structure, structure = _structure === void 0 ? {} : _structure, errorCode = props.errorCode, errorTitle = props.errorTitle;
        if (errorCode) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_error__WEBPACK_IMPORTED_MODULE_2__["default"], {
            statusCode: errorCode,
            title: errorTitle
        });
        if (CustomErrorPage && structure.id && structure.id === "404") return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CustomErrorPage, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props));
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Page, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props));
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (withCustomError);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5338,2182,8934,3661,651,5040,1269,8035,4854,5168,313,4488,1782,4490,5449,8800,2654,8337,1093,2673,7833,920,412,2942,5703,2760,4882,9551,3531,7648,2768,3039,4458,1049,3778,8559,9583,8105,2898,4057,6297,5165,5618,5021,8218,3740,6150,4678,4408,6578,6449,9091,2911,5844,9805,9748,7281,2916,4776,2624,8473,3126,8887,9616,4379,9622,7030,8354,4027,9774,2888,179], function() { return __webpack_exec__(20271); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);